var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionListIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9756 13.9512H19.4146V18.3049C19.4146 18.8171 18.9024 19.3293 18.3902 19.3293H5.58537C4.98781 19.3293 4.56098 18.8171 4.56098 18.3049V13.9512H2V18.3049C2 20.3537 3.62195 21.9756 5.58537 21.9756H18.3902C20.3537 21.9756 21.9756 20.3537 21.9756 18.3049V13.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6219 2C10.1097 2 9.76824 2.2561 9.76824 2.59756V9.59756H7.54873C6.78043 9.59756 6.43897 9.85366 6.78043 10.1951L8.57312 12.2439C8.82921 12.5854 9.34141 13.1829 9.68287 13.5244L11.4756 15.4878C11.7317 15.9146 12.2438 15.9146 12.5853 15.4878L14.2926 13.5244C14.6341 13.1829 15.1463 12.5854 15.4024 12.2439L17.1951 10.1951C17.5365 9.85366 17.1097 9.59756 16.4268 9.59756H14.2073V2.5122C14.2073 2.2561 13.7804 2 13.3536 2H10.6219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionListIconOn);
export default __webpack_public_path__ + "static/media/QuestionListIconOn.69855f6bc841ae556d0f63f7010ccc60.svg";
export { ForwardRef as ReactComponent };